import { createContext, type ReactNode, useContext, useState } from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
interface ErrorContextState {
  error: any;
  setError: any;
}
const homeUrl = '/';
export const ErrorContext = createContext<ErrorContextState | undefined>(undefined);
const RenderErrorComponent = ({ error, children, setError }: any): ReactNode => {
  const navigate = useNavigate();
  if (error) {
    return (
      <Result
        status="500"
        subTitle="Sorry, something went wrong."
        extra={
          <Button
            onClick={() => {
              navigate(homeUrl);
              setError(null);
            }}
            type="primary"
          >
            Back Home
          </Button>
        }
      />
    );
  } else {
    return <>{children}</>;
  }
};
const ErrorContextProvider = ({ children }: { children: ReactNode | ReactNode[] }): ReactNode => {
  const [error, setError] = useState<any>(null);

  return (
    <ErrorContext.Provider value={{ error, setError }}>
      <RenderErrorComponent error={error} setError={setError}>
        {children}
      </RenderErrorComponent>
    </ErrorContext.Provider>
  );
};
export const useError = (): ErrorContextState => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};
export default ErrorContextProvider;
